document.addEventListener('DOMContentLoaded', function() {
  if (window.myProductCardScriptLoaded) return;
  window.myProductCardScriptLoaded = true;
  initProductCards();
  initSwatchOverflow();
});

function initSwatchOverflow() {
  const selector = '.product-color-swatches, .option-selector--color .color-swatch-slider__container';
  const registered = new Set();
  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => update(target));
  });

  function update(container) {
    const swatches = Array.from(container.querySelectorAll('.product-color-swatch'));
    if (!swatches.length || !container.clientWidth) return;
    let more = container.querySelector('.product-color-swatches__more');
    if (!more) {
      more = document.createElement('a');
      more.className = 'product-color-swatches__more text-sm text-current';
      container.append(more);
    }
    const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
    const availableWidth = container.clientWidth;
    const size = parseFloat(getComputedStyle(swatches[0]).width);
    const capacity = Math.floor((availableWidth + gap) / (size + gap));
    const visible = swatches.length > capacity ? Math.max(0, Math.floor((availableWidth - 32) / (size + gap))) : swatches.length;
    swatches.forEach((swatch, index) => {
      const hidden = index >= visible;
      const item = swatch.closest('.color-swatch-slider__slide') || swatch;
      if (item.hidden !== hidden) item.hidden = hidden;
    });
    const remaining = swatches.length - visible;
    const label = `+${remaining}`;
    if (more.textContent !== label) more.textContent = label;
    more.hidden = remaining === 0;
    more.href = container.closest('product-card')?.querySelector('.js-prod-link')?.href || swatches[0].href || swatches[0].dataset.compareColorUrl || window.location.pathname;
  }

  function register(root) {
    const containers = root.matches?.(selector) ? [root] : [];
    containers.push(...root.querySelectorAll(selector));
    containers.forEach((container) => {
      if (registered.has(container)) return;
      registered.add(container);
      observer.observe(container);
      update(container);
    });
  }

  register(document);
  new MutationObserver((records) => {
    records.forEach((record) => {
      record.removedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        registered.forEach((container) => {
          if (node === container || node.contains(container)) {
            observer.unobserve(container);
            registered.delete(container);
          }
        });
      });
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) register(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

function initProductCards() {
  const desktop = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
  const swatchSelector = '.card__color-swatches .product-color-swatch';

  async function showPreview(card, swatch) {
    const preview = card.querySelector('.card__color-preview');
    if (!preview) return;
    const request = (preview.imageRequest || 0) + 1;
    preview.imageRequest = request;
    const imageUrl = swatch?.dataset.swatchImage;
    if (!imageUrl) {
      preview.hidden = true;
      return;
    }

    const image = preview.querySelector('img').cloneNode(false);
    image.src = imageUrl;
    image.alt = swatch.getAttribute('aria-label') || '';
    try {
      await image.decode();
    } catch {
      return;
    }
    if (preview.imageRequest !== request || !card.isConnected) return;

    preview.replaceChildren(image);
    preview.hidden = false;
  }

  function restorePreview(card) {
    showPreview(card, card.selectedProductSwatch);
  }

  document.addEventListener('pointerover', function(event) {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const swatch = event.target.closest(swatchSelector);
    if (swatch && !swatch.contains(event.relatedTarget)) showPreview(swatch.closest('product-card'), swatch);
  });

  document.addEventListener('pointerout', function(event) {
    const swatches = event.target.closest('.card__color-swatches');
    if (!desktop.matches || !swatches || swatches.contains(event.relatedTarget)) return;
    restorePreview(swatches.closest('product-card'));
  });

  document.addEventListener('focusin', function(event) {
    const swatch = event.target.closest(swatchSelector);
    if (desktop.matches && swatch) showPreview(swatch.closest('product-card'), swatch);
  });

  document.addEventListener('focusout', function(event) {
    const swatch = event.target.closest(swatchSelector);
    if (swatch && !swatch.closest('.card__color-swatches').contains(event.relatedTarget)) {
      restorePreview(swatch.closest('product-card'));
    }
  });

  document.addEventListener('click', function(event) {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || desktop.matches || event.button !== 0
      || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();

    const card = swatch.closest('product-card');
    card.selectedProductSwatch = swatch;
    showPreview(card, swatch);
    card.querySelectorAll(swatchSelector).forEach((item) => {
      item.classList.toggle('color-swatch-slider__item--current', item === swatch);
    });
    card.querySelectorAll('.js-prod-link, .quick-add-view-btn').forEach((link) => {
      link.href = swatch.href;
      if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', swatch.getAttribute('aria-label'));
    });
    card.productUrl = swatch.href;

    const quickAdd = card.querySelector('.js-quick-add');
    if (quickAdd) {
      quickAdd.dataset.productUrl = swatch.getAttribute('href');
      quickAdd.dataset.productDefaultVariant = swatch.dataset.productDefaultVariant;
      delete quickAdd.dataset.selectedColor;
    }
    card.querySelectorAll('.js-product-form input[name="id"]').forEach((input) => {
      input.value = swatch.dataset.variantId;
    });
    const checkbox = card.querySelector('.js-compare-checkbox');
    if (checkbox) {
      checkbox.dataset.productId = swatch.dataset.productId;
      checkbox.dataset.productUrl = swatch.getAttribute('href');
      checkbox.checked = false;
      if (typeof CompareUtil !== 'undefined') CompareUtil.updateCompareCheckboxes();
    }
  });

  document.addEventListener('submit', function(event) {
    if (!event.target.matches('.js-product-form')) return;
    const swatch = event.target.closest('product-card')?.selectedProductSwatch;
    if (!swatch || swatch.dataset.productDefaultVariant === 'true') return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(swatch.href);
  }, true);
}
